export default class KMKLabs {
  static global() {
    if (typeof window.kmklabs === 'undefined') {
      return {};
    }

    return window.kmklabs;
  }

  static watermark_timestamp() {
    return this.global().watermark_timestamp;
  }
}
